export default "__VITE_ASSET__Ml3BY4ev__"